export default "__VITE_ASSET__f39f9324__"